export default __webpack_public_path__ + "static/media/noa-46.925201dd.jpg";